const html = require('choo/html')

function getShapes () {
  const shape1 = 'M.18,8.93A8.83,8.83,0,0,1,9,.1H187.13A8.83,8.83,0,0,1,196,'
    + '8.93V205a8.83,8.83,0,0,1-2.59,6.25L155.94,240.9a8.83,8.83,0,0,1-6.25,'
    + '2.59H9a8.83,8.83,0,0,1-8.83-8.83Z'
  const shape2 = 'M196,199.32v-175A7.36,7.36,0,0,0,188.6,17H7.54A7.36,7.36,0,0,'
    + '0,.18,24.32V219.39H0v27a10.37,10.37,0,0,0,10.37,10.37,5.19,5.19,0,0,0,'
    + '5.19-5.19v-6.5h25v7a5,5,0,1,0,10,0v-7h25v7a5,5,0,1,0,10,0v-7h25v7a5,5,'
    + '0,0,0,10,0v-7h25v7a5,5,0,0,0,10,0v-9.47l25-25v3.9a2.94,2.94,0,0,0,5,'
    + '2.08l7.48-7.48a8.83,8.83,0,0,0,2.59-6.25Z'
  const shape3 = 'M85.69,252.14h25s0-.06,0-.09V220.17h0v-1.92a6,6,0,0,'
    + '0-6-6h-13a6,6,0,0,0-6,6v23.63h0v10.16S85.69,252.11,85.69,252.14Z'
  const shape4 = 'M120.78,252.05s0,.06,0,.09h25s0-.06,0-.09V220.17h0v-1.92a6,6,'
    + '0,0,0-6-6h-13a6,6,0,0,0-6,6Z'
  const shape5 = 'M50.63,252.14h25s0-.06,0-.09V220.17h0v-1.92a6,6,0,0,'
    + '0-6-6h-13a6,6,0,0,0-6,6v23.63h0v10.25Z'
  const shape6 = 'M155.85,250,182,223.79a2.88,2.88,0,0,1-1.16-2.34v-3.2a6,6,0,'
    + '0,0-6-6h-13a6,6,0,0,0-6,6Z'
  const shape7 = 'M40.58,220.17v-1.92a6,6,0,0,0-6-6h-13a6,6,0,0,0-6,'
    + '6v23.63h0v10.25h25v-32Z'
  return { shape1, shape2, shape3, shape4, shape5, shape6, shape7 }
}
function cardSvg (title, image) {
  const { shape1, shape2, shape3, shape4, shape5, shape6, shape7 } = getShapes()
  return html`
    <svg
      
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 195.96 257.07">
      <defs>
        <style>
          /* internal border */
          .a {opacity:0.7;}
          /* Rectable inside internal border */
          .b {fill:url(#a);}
          /* Text */
          .title-text {
            font-size:24px;
            fill:#000;
            font-family:LiberatorHeavy, Liberator;
          }
          .cropped {
            clip-path: url(#overflow);
          }
        </style>
        <linearGradient
          id="a"
          x1="814.54"
          y1="114.97"
          x2="980.88"
          y2="114.97"
          gradientTransform="matrix(-1, 0, 0, 1, 995.78, 0)"
          gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color="#1a1d36"/>
          <stop offset="1" stop-color="#12152b"/>
        </linearGradient>
      </defs>

      <clipPath id="overflow">
        <rect x="19.69" y="36.59" width="156.77" height="156.77" rx="6" ry="6"/>
      </clipPath>

      <path class="shade1" d=${shape1}/>
      <path class="shade2" d=${shape2}/>
      <rect class="shade3" x="0.28" y="41.25" width="195.68" height="58.97"/>
      <rect class="shade3" x="0.28" y="121.63" width="195.68" height="21.4"/>
      <g class="a">
        <rect
          class="b"
          x="14.9"
          y="31.8"
          width="166.34"
          height="166.34"
          rx="8"
          ry="8"
          />
      </g>

      <g class="cropped">
        <rect
          class="shade4"
          x="19.69"
          y="36.59"
          width="156.77"
          height="156.77"
          rx="6"
          ry="6"
          />
        <text class="title-text" transform="translate(25.75 183.28)">${title}</text>
      </g>

      <rect
        class="shade5"
        x="50.93"
        width="95.05"
        height="16.96"
        transform="translate(196.91 16.96) rotate(-180)"
        />
      <path class="shade1" d=${shape3}/>
      <path class="shade1" d=${shape4}/>
      <path class="shade1" d=${shape5}/>
      <path class="shade1" d=${shape6}/>
      <path class="shade1" d=${shape7}/>
      <!-- XXX: This image is breaking the svg! Leave to last element -->
      <image
        x="19.69"
        y="36.19"
        width="156.77"
        height="116.77"
        href=${image}
         preserveAspectRatio="xMidYMid slice"
        style="
        clip-path: inset(0 round 6px);">
      </image>
    </svg>
  `
}

function highlightSvg () {
  const shape = 'M4,4L191.96,4L191.96,212.26L153.17,253.07L4,253.07L4,4'
  return html`
  <svg
    class="sd-card-highlight"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 195.96 257.07">
    <path class="highlight-path" d=${shape}></path>
  </svg>
  `
}

module.exports = function SDCard (props) {
  const { title, color, image, disabled, onClick } = props
  return html`
    <div class="sd-card ${color} ${disabled ? 'disabled' : ''}"
       onclick=${onClick}
    >
      ${disabled ? '' : highlightSvg()}
      ${cardSvg(title, image)}
    </div>
  `
}
